import "./style.css";

import { Outlet } from "react-router-dom";
import { Header, Footer } from "components/Layout";
import LoginModal from "components/Modal/Auth/LoginModal";
import RegisterModal from "components/Modal/Auth/RegisterModal";
import ForgotPasswordModal from "components/Modal/Auth/ForgotPasswordModal";
import VerifyPhoneCodeModal from "../../components/Modal/Auth/VerifyPhoneCodeModal";
import HorseFormModal from "components/Modal/Horses/HorseFormModal";
import CongratsModal from "components/Modal/Horses/CongratsModal";
import { useCheckoutReturnModal } from "hooks/useCheckoutReturnModal";

export default () => {
  useCheckoutReturnModal();

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
        <Footer />
      </div>
      <LoginModal />
      <RegisterModal />
      <ForgotPasswordModal />
      <VerifyPhoneCodeModal />
      <HorseFormModal />
      <CongratsModal />
    </>
  );
};
